module.exports = __webpack_public_path__ + "img/first-world-bg.c5c687d7.png";